import { useEffect, useState } from 'react';
import { useNavigate, useLocation, useSearchParams } from 'react-router-dom';
import useCaptcha from 'hooks/useCaptcha';
import { AuthService } from 'services/auth.service';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { TextField, Box } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { ROUTES } from 'utils/constants';
import CaptchaTerms from 'components/atoms/CaptchaTerms';
import { useStyles } from './styles';

function EmailForm() {
  const styles = useStyles();
  const navigate = useNavigate();
  const location = useLocation();
  const { captchaToken } = useCaptcha();

  const [searchParams] = useSearchParams();
  const action = searchParams.get('action');
  const isCompany = action === 'job_open';

  const [email, setEmail] = useState('');

  const schema = Yup.object().shape({
    email: Yup.string()
      .email('Por favor, digite um e-mail válido')
      .max(255, 'O e-mail não pode ter mais de 255 caracteres')
      .required('O e-mail é obrigatório')
  });

  useEffect(() => {
    if (location.state) {
      const { email: newEmail } = location.state;
      setEmail(newEmail ?? '');
    }
  }, []);

  const sendEmail = (newEmail: string) => {
    if (captchaToken) {
      AuthService.codeGenerate(newEmail, isCompany, captchaToken)
        .then(() => {
          navigate(`${ROUTES.ACCESS_CODE}${location.search}`, {
            state: {
              email: newEmail,
              generatedCode: true
            }
          });
        })
        .catch((error) => console.error(error));
    }
  };

  return (
    <Formik
      enableReinitialize
      initialValues={{
        email
      }}
      validationSchema={schema}
      onSubmit={(values) => {
        sendEmail(values.email);
      }}
    >
      {({
        errors,
        handleBlur,
        handleChange,
        handleSubmit,
        isSubmitting,
        touched,
        values
      }) => (
        <Form className={styles.container} onSubmit={handleSubmit}>
          <Box>
            <TextField
              label="Digite seu e-mail"
              value={values.email}
              error={touched.email && !!errors.email}
              helperText={touched.email && errors.email}
              name="email"
              type="email"
              onBlur={handleBlur}
              onChange={handleChange}
              fullWidth
            />
            <CaptchaTerms />
          </Box>
          <LoadingButton
            loading={isSubmitting}
            disabled={isSubmitting}
            type="submit"
          >
            receber código de acesso
          </LoadingButton>
        </Form>
      )}
    </Formik>
  );
}

export default EmailForm;
